import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/servicios/toxicologia/estudios-de-seguimiento")({
  beforeLoad: () => { throw redirect({ href: "/es/servicios/toxicologia-regulatoria/estudios-de-seguimiento", statusCode: 301 }); },
});
